import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

export const STCOfferCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const Content = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
  }
`;

export const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  min-width: auto !important;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: auto;
    min-width: 200px !important;
  }
`;
